import { Observable } from 'rxjs';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { UndoCommand } from './command';
import { CommandEvents } from './command-events';
import { InactiverPointInscriptionAdministrativeCommand } from './inactiver-point-inscription-administrative-command';

export class ReactiverPointInscriptionAdministrativeCommand implements UndoCommand<ObjetMaquette> {
    private reverseCommand: InactiverPointInscriptionAdministrativeCommand;

    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        contexteId: string
    ) {
        this.reverseCommand = new InactiverPointInscriptionAdministrativeCommand(
            codeStructure,
            id,
            version,
            events,
            objetMaquetteService,
            contexteId
        );
    }

    do(): Observable<ObjetMaquette> {
        return this.reverseCommand.undo();
    }

    undo(): Observable<ObjetMaquette> {
        return this.reverseCommand.do();
    }

    destroy(): void {
        this.reverseCommand.destroy();
    }
}
